import { render, staticRenderFns } from "./BookingSlotDay.vue?vue&type=template&id=26003064&"
import script from "./BookingSlotDay.vue?vue&type=script&lang=js&"
export * from "./BookingSlotDay.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlotDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports